<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <h3>Users</h3>
      </div>
      <!-- {{generalPermissions}} -->
      <!-- {{ showAdduser }} -->
      <div v-if="user_permissions.canshowAdduser" class="col-md-4 offset-md-4">
        <p-button
          class="btn btn-success pull-right"
          @click="handleAddUserButton"
          v-if="hasAddNewUserPermission"
        >
          <i class="fas fa-user"></i> Add a new User
        </p-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 card">
        <div class="card-body row">
          <div class="col-2">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
              size="mini"
              @input="inputChangedstart()"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table
              class="table-striped"
              :data="tableData"
              border
              style="width: 100%"
            >
              <el-table-column
                v-for="column in tableColumns"
                align="center"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              ></el-table-column>
              <el-table-column
                :min-width="80"
                fixed="right"
                align="center"
                class-name="td-actions"
                label="Actions"
              >
                <template slot-scope="props">
                  <p-button
                    v-if="user_permissions.canshowRolePut"
                    type="warning"
                    size="sm"
                    icon
                    @click="handleUserEdit(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </p-button>
                  <!-- <p-button
                    type="info"
                    size="sm"
                    icon
                    @click="handleLink(props.$index, props.row)"
                  >
                    <i class="fa fa-link"></i>
                  </p-button> -->
                  <p-button
                    v-if="user_permissions.canshowAdduser"
                    type="warning"
                    size="sm"
                    icon
                    @click="handleUserchangepassword(props.$index, props.row)"
                  >
                    <i class="fa fa-key"></i>
                  </p-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              @input="inputChanged($event)"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- add user modal -->
    <modal
      :show.sync="addNewUser"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h5 slot="header" class="text-primary modal-title" v-if="!isEditing">
        Add a new User
      </h5>
      <h5 slot="header" class="text-primary modal-title" v-else>Edit User</h5>
      <template>
        <!-- {{ userModel }} -->

        <form
          @submit.prevent="validateForm('userModel')"
          data-vv-scope="userModel"
        >
          <ValidationObserver ref="c">
            <el-form ref="form" slot-scope="{ validate }" class="w-full">
              <InputWithValidation
                v-model="userModel.username"
                rules="required"
                label="username"
              />
              <InputWithValidation
                v-model="userModel.email"
                rules="required|email"
                label="Email"
              />
              <SelectWithValidation
                rules="required"
                :placeholder="selectRoles"
                v-model="userModel.role_id"
              >
                <el-option
                  class="w-full"
                  v-for="role in roles"
                  :value="role.id"
                  :key="role.id"
                  :label="role.role_name"
                ></el-option>
              </SelectWithValidation>

              <InputWithValidation
                v-model="userModel.password"
                type="password"
                rules="required|min:5"
                label="Password"
                vid="password"
              />

              <InputWithValidation
                v-model="userModel.confirmPassword"
                type="password"
                rules="required|confirmed:password"
                label="confirm Password "
              />
              <el-form-item>
                <p-button
                  type="success"
                  :disabled="isactive"
                  class="mr-4"
                  @click="validate().then(addUser)"
                  >Save</p-button
                >
                <!-- <el-button @click="resetForm">Reset</el-button> -->
                <p-button type="danger" @click.native="addNewUserclose()"
                  >Close</p-button
                >
              </el-form-item>
            </el-form>
          </ValidationObserver>
        </form>
        <!-- {{userModel}} -->
      </template>
      <template slot="footer">
        <!-- <p-button type="success" @click.native="editUser" v-else>Save</p-button> -->
      </template>
    </modal>

    <!-- editRole modal -->
    <modal
      :show.sync="editRole"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h5 slot="header" class="text-primary modal-title" v-if="!isEditing">
        Edit User Role
      </h5>
      <h5 slot="header" class="text-primary modal-title" v-else>
        Edit user role
      </h5>
      <template>
        <div class="form-group">
          <fg-input
            label="Username"
            name="username"
            :disabled="true"
            v-model="username"
          ></fg-input>
        </div>

        <ValidationObserver ref="b">
          <el-form ref="form" slot-scope="{ validate }" class="w-full">
            <SelectWithValidation
              rules="required"
              :placeholder="selectRoles"
              v-model="edituserModel.role_id"
            >
              <el-option
                class="w-full"
                v-for="role in roles"
                :value="role.id"
                :key="role.id"
                :label="role.role_name"
              ></el-option>
            </SelectWithValidation>
            <el-form-item>
              <p-button
                type="success"
                class="mr-4"
                @click="validate().then(editUserRole)"
                >Save</p-button
              >
              <!-- <el-button @click="resetForm">Reset</el-button> -->
              <p-button type="danger" @click.native="editRole = false"
                >Close</p-button
              >
            </el-form-item>
          </el-form>
        </ValidationObserver>
      </template>
      <template slot="footer"> </template>
    </modal>

    <!-- edit password modal -->
    <modal
      :show.sync="editpasswordModal"
      footer-classes="justify-content-center"
      type="notice"
    >
      <h5 slot="header" class="text-primary modal-title" v-if="!isEditing">
        Edit user Password
      </h5>
      <template>
        <ValidationObserver ref="a">
          <el-form ref="form" slot-scope="{ validate }">
            <div v-if="editRoleModel" class="pb-2">
              Username: {{ editRoleModel.username }}
            </div>

            <InputWithValidation
              v-model="passwordModel.password"
              type="password"
              rules="required|min:5"
              label="Password"
              vid="password"
            />

            <InputWithValidation
              v-model="passwordModel.confirmPassword"
              type="password"
              rules="required|confirmed:password"
              label="confirm Password "
            />

            <div class="">
              <el-form-item>
                <p-button
                  type="success"
                  class="mr-4"
                  @click="validate().then(savepassword)"
                  >Create</p-button
                >
                <!-- <el-button @click="resetForm">Reset</el-button> -->
                <p-button type="danger" @click.native="closechangepassword()"
                  >Close</p-button
                >
              </el-form-item>
            </div>
          </el-form>
        </ValidationObserver>

        <!-- {{userModel}} -->
      </template>
    </modal>
  </div>
</template>
<script>
import users from "src/components/Dashboard/Views/Tables/users";
import HTTP from "src/util/http-common.js";
import Modal from "src/components/UIComponents/Modal.vue";
import swal from "sweetalert2";
import { ValidationObserver } from "vee-validate";
import InputWithValidation from "./input/InputWithValidation.vue";
import SelectWithValidation from "./input/SelectWithValidation.vue";
import CheckboxesWithValidation from "./input/CheckboxesWithValidation.vue";

export default {
  components: {
    Modal,
    ValidationObserver,
    InputWithValidation,
    SelectWithValidation,
    CheckboxesWithValidation,
  },
  data() {
    return {
      isactive: false,
      user_permissions: {
        canshowAdduser: false,
        canshowRolePut: false,
      },
      selectRoles: "select role",

      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [2, 5, 10, 25, 50],
        total: 0,
      },
      tableColumns: [
        {
          prop: "role.role_name",
          label: "role",
          minWidth: 110,
        },
        {
          prop: "username",
          label: "Username",
          minWidth: 150,
        },
        {
          prop: "epoch_created_at",
          label: "Created At",
          minWidth: 200,
        },
      ],
      tableData: [],
      addNewUser: false,
      editRole: false,
      isAdding: false,
      isEditing: false,
      editpasswordModal: false,
      dbroles: [],
      userModel: {
        username: null,
        email: null,
        password: null,
        confirmPassword: null,
        role_id: null,
      },
      passwordModel: {
        password: null,
        confirmPassword: null,
      },
      editRoleModel: null,
      roles: [],
      username: null,
      edituserModel: {
        // role: null,
        role_id: null,
      },
      isuserpassediting: false,
      roles: [],
      generalPermissions: this.$store.getters["auth/generalPermissions"],
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    hasAddNewUserPermission() {
      if (this.user_permissions.canshowAdduser) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "pagination.perPage": function (newVal, oldVal) {
      this.pagination.currentPage = 1;
      // this.setBookings();
    },
    addNewUser: function (newVal, oldVal) {
      if (newVal == false) {
        this.userModel.username = null;
        this.userModel.email = null;
        this.userModel.password = null;
        this.userModel.confirmPassword = null;
        this.userModel.role = null;
        this.userModel.role_id = null;
      } else {
        this.$validator.errors.clear();
        this.setRoles();
      }
    },
    editRole: function (newVal, oldVal) {
      //edituserModel

      if (newVal == false) {
        //  this.edituserModel.role = null;
        this.edituserModel.role_id = null;
      } else {
        this.$validator.errors.clear();
        this.setRoles();
      }
    },
  },
  created() {
    //   this.setSites()
    this.setUsers();
    this.fetchRoles();
    this.userModel.username = null;
    this.userModel.email = null;
    this.userModel.password = null;
    this.userModel.confirmPassword = null;
    this.userModel.role = null;
    this.userModel.role_id = null;
    this.checkPermissions();
  },
  mounted() {
    this.isactive = false;
    var p = localStorage.getItem("permissions");
    var pr = JSON.parse(p);
    var permissions = pr.permissions;

    var canShowusers = permissions.includes("role.post" || "user.get");

    if (canShowusers === false) {
      this.$router.push({ path: "/" });
    }
  },

  methods: {
    checkPermissions() {
      //this.showAdduser
      var p = localStorage.getItem("permissions");
      var pr = JSON.parse(p);
      var permissions = pr.permissions;
      this.user_permissions.canshowAdduser = permissions.includes("user.post");
      this.user_permissions.canshowRolePut = permissions.includes("role.put");
    },
    addNewUserclose() {
      this.addNewUser = false;
    },

    onSubmit() {
      console.log("Form submitted yay!");
    },
    resetForm() {
      requestAnimationFrame(() => {
        this.$refs.a.reset();
        this.$refs.b.reset();
        this.$refs.c.reset();
      });
    },
    handleLink(index, row) {
      this.$router.push({ path: `/users/${row.id}` });
    },
    async inputChangedstart() {
      this.currentPage = 1;
      let params = {
        page: 1,
        page_size: this.pagination.perPage,
      };
      if (this.siteFilter != null) {
        params["site_id"] = this.siteFilter;
      }

      HTTP.get("api/v1/user/list", {
        params: params,
      })
        .then((data) => {
          const results = data.results;
          this.pagination.total = data.total;
          for (let i of results) {
            this.tableData.push(i.user);
          }
          loader.hide();
        })
        .catch((err) => {
          console.log(err.response.data.error);
          const error = err.response.data.error;
          this.$notify({
            group: "general",
            title: "Error fetching user list",
            text: error,
            type: "error",
          });
          loader.hide();
        });
    },
    inputChanged(pageNum) {
      this.setUsers();
    },
    async fetchUsers() {
      let params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.perPage,
      };
      if (this.siteFilter != null) {
        params["site_id"] = this.siteFilter;
      }

      const response = await HTTP.get("api/v1/user/list", {
        params: params,
      });
      const data = await response.data;
      return data;
    },
    setUsers() {
      this.tableData = [];
      let loader = this.$loading.show();
      this.fetchUsers()
        .then((data) => {
          const results = data.results;
          this.pagination.total = data.total;
          for (let i of results) {
            var user = i.user;

            user.role = i.role;
            // user.site= i.site
            // user.id= i.id

            user.epoch_created_at = this.$moment
              .unix(user.epoch_created_at)
              .format("MMMM Do YYYY, h:mm:ss a");

            this.tableData.push(user);
          }
          loader.hide();
        })
        .catch((err) => {
          console.log(err.response.data.error);
          const error = err.response.data.error;
          this.$notify({
            group: "general",
            title: "Error fetching user list",
            text: error,
            type: "error",
          });
          loader.hide();
        });
    },
    handleAddUserButton() {
      this.addNewUser = true;
      this.$refs.c.reset();
      this.errors.clear("userModel");
    },

    handleUserEdit(index, row) {
      //  this.errors.clear("edituserModel");

      this.isuserpassediting = false;
      this.editRoleModel = row;
      this.editRole = true;
      this.username = row.username;
      this.edituserModel.role_id = row.role_id;

      this.$refs.b.reset();
    },
    handleUserchangepassword(index, row) {
      this.resetForm();
      this.editRoleModel = row;
      this.editpasswordModal = true;
      this.passwordModel.password = null;
      this.passwordModel.confirmPassword = null;
      this.errors.clear("passwordModel");
    },
    closechangepassword() {
      (this.editpasswordModal = false), (this.passwordModel.password = null);
      this.errors.clear("passwordModel");
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async addUser() {
      this.validateForm("userModel");
      // this.createUserAPI();
    },
    async savepassword() {
      this.validateForm("passwordModel");
    },
    async validateForm(scope) {
      this.isactive = true;
      this.getError();

      var isValid = this.$validator.validateAll(scope).then((result) => {
        if (result) {
          // eslint-disable-next-line

          if (scope === "edituserModel") {
            this.EditUserAPI();
          }
          if (scope === "userModel") {
            this.createUserAPI();
          }
          if (scope === "passwordModel") {
            this.savepasswordApi();
          }
          //   alert("Form Submitted!");
        } else {
          // alert(`${scope}+ invalid`);
          this.isactive = false;
        }
      });

      return {
        isValid,
      };
    },
    async editUserRole() {
      this.isuserpassediting = true;

      if (this.edituserModel.role_id) {
        this.EditUserAPI();
      }
      //  this.$validator.errors.clear();
      //   this.validateForm("edituserModel");
    },
    async savepasswordApi() {
      HTTP.post(`/api/v1/user/password/${this.editRoleModel.id}`, {
        password: this.passwordModel.password,
        password_2: this.passwordModel.confirmPassword,
      })
        .then((response) => {
          this.setUsers();
          this.editpasswordModal = false;
          swal({
            title: response.data.msg,
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success",
          });
        })
        .catch((err) => {
          this.editpasswordModal = false;

          console.log(err.response);

          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const reason = err.response.data.message;
            const status_code = err.response.status;

            if (status_code == 400) {
              swal({
                title: "Validation Error",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            } else if (status_code) {
              swal({
                title: "Validation Error",
                text: err.response.data.message || err.response.data.errors,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: error.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: error.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          }
        });
    },

    async EditUserAPI() {
      this.$validator.errors.clear();

      console.log(this.pickedRole, "roleid");
      HTTP.post(`/api/v1/user/change_role/${this.editRoleModel.id}`, {
        role_id: this.edituserModel.role_id,
      })
        .then((response) => {
          this.resetForm();
          this.pickedRolewarn = false;
          this.editRole = false;
          this.setUsers();
          this.isuserpassediting = false;
          swal({
            title: response.data.msg,
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success",
          });
        })
        .catch((err) => {
          this.addNewUser = false;

          console.log(err.response);

          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const reason = err.response.data.message;
            const status_code = err.response.status;

            if (status_code == 400) {
              swal({
                title: "Validation Error",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            } else if (status_code) {
              swal({
                title: "Validation Error",
                text: err.response.data.message || err.response.data.errors,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: error.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: error.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          }
          this.isuserpassediting = false;
        });
      this.isuserpassediting = false;
    },
    async createUserAPI() {
      let loader = this.$loading.show();
      HTTP.post("auth/registration", {
        username: this.userModel.username,
        email: this.userModel.email,
        password: this.userModel.password,
        confirmPassword: this.userModel.confirmPassword,
        role_id: this.userModel.role_id,
      })

        .then((response) => {
          this.isactive = false;
          loader.hide();
          this.addNewUser = false;
          this.$refs.c.reset();
          this.setUsers();
          swal({
            title: "Successfully user added",
            text: "",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success btn-fill",
            type: "success",
          });
        })
        .catch((err) => {
          this.isactive = false;
          loader.hide();
          this.addNewUser = false;
          this.addinguser = false;
          console.log(err.response);

          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const reason = err.response.data.message;
            const status_code = err.response.status;

            if (status_code == 400) {
              swal({
                title: "Validation Error",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            } else if (status_code) {
              swal({
                title: "Validation Error",
                text: err.response.data.message || err.response.data.errors,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error",
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: error.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: error.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error",
            });
          }
        });
    },
    async fetchRoles() {
      const response = await HTTP.get("api/v1/role/list", {});
      const data = await response.data;
      return data;
    },
    setRoles() {
      this.fetchRoles().then((data) => {
        this.roles = data;
      });
    },
    async fetchRoles() {
      const response = await HTTP.get("api/v1/role/list", {});
      const data = await response.data;
      this.dbroles = data;
      return data;
    },
  },
};
</script>
<style scoped lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
.err-text {
  color: red;
  font-size: 14px;
}
.err-border-inp {
  border-color: #f22435;
  width: 100%;
  outline: none;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  background-color: #fff;
}
.w-32 {
  width: 40rem;
}
.w-full {
  width: 100%;
}
</style>
